import { Component } from '@angular/core';

@Component({
  selector: 'app-auth-mfa',
  templateUrl: './auth-mfa.component.html',
  styleUrls: ['./auth-mfa.component.scss']
})
export class AuthMfaComponent {

}
